import React from "react";

const SlideHeader = ({ text }) => (
    <h1 className="center c__secondary pb__m">{text}</h1>
);


export default SlideHeader;